module.exports = __webpack_public_path__ + "static/grid-cc-final-b70b4eac5c127ec254d2cb55caaf8391.mp4";